import Footer from "../../../component/Footer";
import { Link } from "react-router-dom";
import Sidebar from "../AdminComp/Sidebar";
import BreadCrumb from "../AdminComp/BreadCrumb";
import { Edit, Trash2 } from "react-feather";

function AdminBookingNavbar() {
  
  
  return (
    <>
       <div className="text-start mb-3">
                {/* <Link to="/admin-hotel-booking-report" className="btn3 me-2 txt71">Booking Report</Link> */}
                <Link to="/admin-hotel-booking-report" className="btn3 me-2 txt71">Hotel Booking Report</Link>
                <Link to="/admin/admin-flight-report" className="btn3 me-2 txt71">Flight Booking Report</Link>
                <Link to="/admin/admin-bus-report" className="btn3 me-2 txt71">Bus Booking Report</Link>
                <Link to="/admin/staff-report" className="btn3 me-2 txt71">Staff/Employee Report</Link>
                <Link to="/admin/agent-report"  className="btn3 me-2 txt71">Agent Report</Link> 
                <Link to="/admin/state-head-report"  className="btn3 me-2 txt71">State Head Report</Link> 
                <Link to="/admin/gst-report"  className="btn3 me-2 txt71">GST Report</Link> 
                <Link to="/admin/admin-cashback-report"  className="btn3 me-2 txt71">Cashback Report</Link> 
                <Link to="/admin/admin-mobile-report"  className="btn3 me-2 txt71">Mobile Recharge Report</Link> 
                <Link to="/admin/admin-dth-report"  className="btn3 me-2 txt71">DTH Recharge Report</Link> 
              </div>
    </>
  );
}

export default AdminBookingNavbar;
